import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL, LOCATION_ID, TOKEN } from '..';
import { Icon } from "@iconify/react";

const DashBoardLayerTwo = () => {
  const currentUser = JSON.parse(localStorage.getItem('user'));
  const locationId = localStorage.getItem('locationID')
   const token = localStorage.getItem('tokenID')
  /* DATE DEFAULTS */
  const today = new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
  const formatDate = (d) => d.toISOString().split("T")[0];

  const [fromDate, setFromDate] = useState(formatDate(firstDay));
  const [toDate, setToDate] = useState(formatDate(today));

const formatCurrency = (num) =>
  Number(num || 0).toLocaleString("en-PK", {
    minimumFractionDigits: 0,
  });


  const [summary, setSummary] = useState({
    totalCash: 0,
    totalIncome: 0,
    totalExpense: 0,
    netProfitLoss: 0,
    accounts: [],
    totalReceivables: 0,
    totalPayables: 0,
    recentTransactions: []
  });

  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);

  /* MAIN FETCH */
  const fetchAccountingDashboard = async () => {
    try {
      if (!fromDate || !toDate) return;
      setLoading(true);

      const response = await fetch(
        `${API_URL}/api/user/dashboard/accounting?startDate=${fromDate}&endDate=${toDate}&locationId=${locationId}`
      );
      const json = await response.json();

      if (json.success) setSummary(json.summary);

      setLoading(false);
    } catch (error) {
      console.error("Dashboard fetch failed:", error);
    }
  };

  const handleFilter = () => fetchAccountingDashboard();

  /* LOCATIONS */
  const locationIds = currentUser?.roles?.locationIds || [];

  const fetchLocationDetails = async (locationId) => {
    try {
      const { data } = await axios.get(
        `https://services.leadconnectorhq.com/locations/${locationId}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Version: '2021-07-28',
            'Content-Type': 'application/json',
          },
        }
      );

      return {
        id: locationId,
        name: data.location?.name || 'Unknown Name',
        info: data.location,
      };
    } catch (error) {
      return { id: locationId, name: 'Error', info: { error: error.message } };
    }
  };

  const fetchAllLocations = async () => {
    const all = [];
    for (const id of locationIds) {
      const single = await fetchLocationDetails(id);
      all.push(single);
      await new Promise((r) => setTimeout(r, 100));
    }
    setResults(all);
  };

  useEffect(() => {
    fetchAllLocations();
    fetchAccountingDashboard();
  }, []);

  return (
    <section className="container-fluid">

      {/* ===================== FILTERS ROW ===================== */}
      <div className="row mb-4 align-items-end">

        <div className="col-md-3">
          <label className="form-label fw-semibold small">Location</label>
          <select className="form-select shadow-sm">
            {results
              .filter((item) => item.name !== "Error")
              .map((e) => (
                <option key={e.id}>{e.name}</option>
              ))}
          </select>
        </div>

        <div className="col-md-3">
          <label className="form-label fw-semibold small">From Date</label>
          <input
            type="date"
            className="form-control shadow-sm"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>

        <div className="col-md-3">
          <label className="form-label fw-semibold small">To Date</label>
          <input
            type="date"
            className="form-control shadow-sm"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>

        <div className="col-md-3">
          <button className="btn btn-dark w-100" onClick={handleFilter}>
            Apply Filters
          </button>
        </div>

      </div>

      {/* ===================== SUMMARY CARDS ===================== */}
      <div className="row g-3">

        <div className="col-lg-3 col-sm-6">
          <div className="card border shadow-sm p-3">
            <p className="text-muted small mb-1">Total Cash</p>
            <h6 className="fw-bold mb-0">Rs. {formatCurrency(summary.totalCash)}</h6>
          </div>
        </div>

        <div className="col-lg-3 col-sm-6">
          <div className="card border shadow-sm p-3">
            <p className="text-muted small mb-1">Total Income</p>
            <h6 className="fw-bold mb-0">Rs. {formatCurrency(summary.totalIncome)}</h6>
          </div>
        </div>

        <div className="col-lg-3 col-sm-6">
          <div className="card border shadow-sm p-3">
            <p className="text-muted small mb-1">Total Expense</p>
            <h6 className="fw-bold mb-0">Rs. {formatCurrency(summary.totalExpense)}</h6>
          </div>
        </div>

        <div className="col-lg-3 col-sm-6">
          <div className="card border shadow-sm p-3">
            <p className="text-muted small mb-1">Net Profit / Loss</p>
            <h6 className="fw-bold mb-0">Rs. {formatCurrency(summary.netProfitLoss)}</h6>
          </div>
        </div>

      </div>

      {/* ===================== ACCOUNTS ===================== */}
      <div className="row mt-4 g-3">

   

        <div className="col-lg-6">
          <div className="row g-3">

            <div className="col-sm-6">
              <div className="card border shadow-sm p-3 rounded-3">
                <p className="text-muted small mb-1">Total Receivables</p>
                <h6 className="fw-bold mb-0">
                  Rs. {formatCurrency(summary.totalReceivables)}
                </h6>
              </div>
            </div>

            <div className="col-sm-6">
              <div className="card border shadow-sm p-3 rounded-3">
                <p className="text-muted small mb-1">Total Payables</p>
                <h6 className="fw-bold mb-0">
                  Rs. {formatCurrency(summary.totalPayables)}
                </h6>
              </div>
            </div>

          </div>
        </div>

      </div>

      {/* ===================== RECENT TRANSACTIONS ===================== */}
       <div className="row g-3 mt-8">
           <div className="col-lg-6">
          <div className="card border shadow-sm p-3 rounded-3">
            <h6 className="fw-bold mb-3">
              <Icon icon="mdi:bank" className="me-2 mb-2" /> Accounts Overview
            </h6>

            {summary.accounts.length === 0 ? (
              <p className="text-muted small">No accounts available</p>
            ) : (
              <ul className="list-group">
                {summary.accounts.map((acc) => (
                  <li
                    key={acc.id}
                    className="list-group-item d-flex justify-content-between small"
                  >
                    <span>
                      <strong>{acc.type}</strong> — {acc.accountTitle}
                    </span>
                    <span className="fw-bold">Rs. {formatCurrency(acc.balance)}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
         <div className="col-lg-6">
      <div className="card border shadow-sm rounded-3 ps-1 pe-1">
        <h6 className="fw-bold  p-3">
          <Icon icon="mdi:history" className="me-2 mb-2" /> Recent Transactions
        </h6>

        <table className="table table-sm table-hover align-middle">
          <thead className="table-light">
            <tr className="small">
              <th>Date</th>
              <th>Description</th>
              <th>Account</th>
              <th className="text-success">Credit</th>
              <th className="text-danger">Debit</th>
            </tr>
          </thead>
          <tbody>
            {summary.recentTransactions?.map((t, i) => (
              <tr key={i} className="small">
                <td>{t.date}</td>
                <td>{t.title}</td>
                <td>{t.accountName}</td>
                <td className="text-success fw-bold">
                  {formatCurrency(t.in)}
                </td>
                <td className="text-danger fw-bold">
                  {formatCurrency(t.out)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      </div>
      </div>

    </section>
  );
};

export default DashBoardLayerTwo;
